define(
    'NMSDesignSystem.Shopping',
    [
        'NMSDesignSystem.StartupData.Shopping',
        'NMSDesignSystem.Header',
        'NMSDesignSystem.CrossAppWarmup',
        'NMSDesignSystem.PLP.Shopping',
        'NMSDesignSystem.FeaturedProducts.Shopping',
        'NMSDesignSystem.InitialHome.Shopping',
        'NMSDesignSystem.InitialContent.Shopping',
        'NMSDesignSystem.FluReimbursement.Shopping',
        'NMSDesignSystem.PDP.Shopping',
        'NMSDesignSystem.SEO.Shopping',
        'NMSDesignSystem.Cart.Shopping',
        'NMSDesignSystem.ProductionCompatibility.Shopping',
        'NMSDesignSystem.CookieConsent',
        'NMSDesignSystem.ContentPages.Shopping',
        'NMSDesignSystem.GlobalFooter',
        'NMSDesignSystem.GlobalStates',
        'QuickAdd.Item.View',
        'SC.Shopping.Layout',
        'nms_sca261_shopping_layout.tpl',
        'underscore'
    ],
    function NMSDesignSystemShopping(NMSDesignSystemStartupDataShopping, NMSDesignSystemHeader, NMSDesignSystemCrossAppWarmup, NMSDesignSystemPLPShopping, NMSDesignSystemFeaturedProductsShopping, NMSDesignSystemInitialHomeShopping, NMSDesignSystemInitialContentShopping, NMSDesignSystemFluReimbursementShopping, NMSDesignSystemPDPShopping, NMSDesignSystemSEOShopping, NMSDesignSystemCartShopping, NMSDesignSystemProductionCompatibilityShopping, NMSDesignSystemCookieConsent, NMSDesignSystemContentPagesShopping, NMSDesignSystemGlobalFooter, NMSDesignSystemGlobalStates, QuickAddItemView, ShoppingLayoutModule, nmsSca261ShoppingLayoutTpl, _) {
        'use strict';

        function redirectRetiredBfsOrderRoute() {
            var location;
            var hostname;
            var pathname;
            var fragment;
            var isBfs;
            var isServerRoute;
            var isLocalRoute;

            if (typeof window === 'undefined' || !window.location) {
                return false;
            }

            location = window.location;
            hostname = String(location.hostname || '').toLowerCase();
            pathname = String(location.pathname || '').replace(/\/+$/, '');
            fragment = String(location.hash || '')
                .replace(/^#\/?/, '')
                .split('?')[0]
                .replace(/\/+$/, '');
            isBfs = ['buyflushots.nmsincusa.com', 'buyflu-sandbox.ethanablatt.com']
                .indexOf(hostname) !== -1;
            isServerRoute = ['/prebook', '/pre-book'].indexOf(pathname) !== -1;
            isLocalRoute = /shopping-local\.ssp$/i.test(pathname) &&
                ['prebook', 'pre-book'].indexOf(fragment) !== -1;

            if (!isBfs || !isServerRoute && !isLocalRoute) {
                return false;
            }

            location.replace(isLocalRoute
                ? pathname + (location.search || '') + '#/products'
                : '/products');
            return true;
        }

        function installApplicationLayoutTemplate(container) {
            var ShoppingLayout = ShoppingLayoutModule && (
                ShoppingLayoutModule.ShoppingLayout || ShoppingLayoutModule
            );
            var layout = container && container.getLayout && container.getLayout();

            if (ShoppingLayout && ShoppingLayout.prototype) {
                ShoppingLayout.prototype.template = nmsSca261ShoppingLayoutTpl;
            }
            if (layout) {
                layout.template = nmsSca261ShoppingLayoutTpl;
            }
        }

        function formatProductName(value) {
            var acronyms = {
                CDC: true,
                CSOS: true,
                DEA: true,
                EMS: true,
                FDA: true,
                IM: true,
                IV: true,
                NDC: true,
                NMS: true,
                OTC: true,
                PPE: true,
                RX: true,
                SQ: true,
                USA: true,
                USP: true
            };
            var units = {
                BX: true,
                CC: true,
                EA: true,
                G: true,
                MCG: true,
                MG: true,
                ML: true,
                UM: true,
                VL: true
            };
            var text = String(value || '');
            var letters = text.replace(/[^A-Za-z]/g, '');

            if (!letters || letters !== letters.toUpperCase()) {
                return text;
            }

            return text.toLowerCase().replace(/[a-z0-9][a-z0-9'’/.#-]*/gi, function formatToken(token) {
                return token.split(/([/-])/).map(function formatPart(part) {
                    var upper = part.toUpperCase();
                    var unitMatch = upper.match(/^(\d+(?:\.\d+)?)([A-Z]+)$/);

                    if (part === '/' || part === '-') {
                        return part;
                    }
                    if (acronyms[upper] || units[upper]) {
                        return upper;
                    }
                    if (unitMatch && units[unitMatch[2]]) {
                        return unitMatch[1] + unitMatch[2];
                    }
                    if (/^\d+$/.test(part)) {
                        return part;
                    }

                    return part.charAt(0).toUpperCase() + part.slice(1);
                }).join('');
            });
        }

        function mountQuickAddProductNames() {
            var prototype = QuickAddItemView && QuickAddItemView.prototype;
            var originalGetContext;

            if (!prototype || typeof prototype.getContext !== 'function' || prototype.nmsDesignSystemProductNameContext) {
                return;
            }

            originalGetContext = prototype.getContext;
            prototype.getContext = function getNMSQuickAddContext() {
                var context = originalGetContext.apply(this, arguments);
                var viewModel = this.model;
                var sourceModel = (context && context.model) || viewModel;
                var model = sourceModel && sourceModel.toJSON
                    ? sourceModel.toJSON()
                    : sourceModel;
                var nativeItem = viewModel && typeof viewModel.get === 'function'
                    ? viewModel.get('item')
                    : null;
                var item = nativeItem || (model && model.item);

                if (item && item.toJSON) {
                    item = item.toJSON();
                }

                if (context && (item && item._name || model && model.displayname)) {
                    context = _.extend({}, context, {
						displayName: formatProductName(item && item._name || model.displayname),
						model: _.extend({}, model, {
							displayname: formatProductName(item && item._name || model.displayname)
						})
                    });
                }

                return context;
            };
            prototype.nmsDesignSystemProductNameContext = true;
        }

        return {
            mountToApp: function mountToApp(container) {
                if (redirectRetiredBfsOrderRoute()) {
                    return;
                }

                installApplicationLayoutTemplate(container);
                NMSDesignSystemStartupDataShopping.mountToApp(container);
                NMSDesignSystemHeader.mountToApp(container);
                NMSDesignSystemCrossAppWarmup.mountToApp(container);
                NMSDesignSystemPLPShopping.mountToApp(container);
                NMSDesignSystemFeaturedProductsShopping.mountToApp(container);
                NMSDesignSystemInitialHomeShopping.mountToApp(container);
                NMSDesignSystemInitialContentShopping.mountToApp(container);
                NMSDesignSystemFluReimbursementShopping.mountToApp(container);
                NMSDesignSystemPDPShopping.mountToApp(container);
                NMSDesignSystemSEOShopping.mountToApp(container);
                NMSDesignSystemCartShopping.mountToApp(container);
                NMSDesignSystemProductionCompatibilityShopping.mountToApp(container);
                NMSDesignSystemCookieConsent.mountToApp(container);
                NMSDesignSystemContentPagesShopping.mountToApp(container);
                NMSDesignSystemGlobalFooter.mountToApp(container);
                NMSDesignSystemGlobalStates.mountToApp(container);
                mountQuickAddProductNames();
            }
        };
    }
);
